if (!customElements.get('sku-product-title-fit')) {
  customElements.define(
    'sku-product-title-fit',
    class SkuProductTitleFit extends HTMLElement {
      connectedCallback() {
        this.titleElement = this.querySelector('.sku-product-tile__title');
        if (!this.titleElement) return;

        this.resizeObserver = new ResizeObserver((entries) => {
          const width = Math.round(entries[0].contentRect.width);
          if (width === this.lastWidth) return;

          this.lastWidth = width;
          this.requestFit();
        });
        this.resizeObserver.observe(this);
        this.requestFit();

        if (document.fonts?.ready) {
          document.fonts.ready.then(() => this.requestFit());
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.fitFrame);
      }

      requestFit() {
        cancelAnimationFrame(this.fitFrame);
        this.fitFrame = requestAnimationFrame(() => this.fitTitle());
      }

      fitTitle() {
        const title = this.titleElement;
        const availableWidth = this.clientWidth;
        if (!title || availableWidth <= 0) return;

        title.style.removeProperty('font-size');
        const preferredFontSize = Number.parseFloat(getComputedStyle(title).fontSize);
        if (title.scrollWidth <= availableWidth) return;

        const minimumFontSize = Math.min(9, preferredFontSize);
        let smallestFit = minimumFontSize;
        let largestFit = preferredFontSize;

        for (let step = 0; step < 8; step += 1) {
          const candidate = (smallestFit + largestFit) / 2;
          title.style.fontSize = `${candidate}px`;

          if (title.scrollWidth <= availableWidth) {
            smallestFit = candidate;
          } else {
            largestFit = candidate;
          }
        }

        title.style.fontSize = `${smallestFit}px`;
      }
    }
  );
}
